import { useState } from 'react';
import toast from 'react-hot-toast';

interface UseSubmitActionOptions {
  cooldownMs?: number;
  onSuccess?: () => void;
  successMessage?: string;
}

export function useSubmitAction<TArgs extends any[]>(
  actionFn: (...args: TArgs) => Promise<any>,
  options?: UseSubmitActionOptions
) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isCooldown, setIsCooldown] = useState(false);

  const execute = async (...args: TArgs) => {
    if (isSubmitting || isCooldown) return;
    
    setIsSubmitting(true);
    try {
      await actionFn(...args);
      
      if (options?.successMessage) {
        toast.success(options.successMessage);
      }
      if (options?.onSuccess) {
        options.onSuccess();
      }
      
      // Start cooldown ONLY on success
      setIsCooldown(true);
      setTimeout(() => {
        setIsCooldown(false);
      }, options?.cooldownMs || 5000);
      
    } catch (err: any) {
      toast.error(err.message || 'Có lỗi xảy ra');
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    isSubmitting,
    isCooldown,
    isDisabled: isSubmitting || isCooldown,
    execute
  };
}
